import { ApiUrls } from '@api/apiUrls';
import { fetchApi } from 'api/fetchApi';
import { IApiMTradingAccount } from 'api/interfaces/data-contracts';

export interface IAccountCreatedResponse {
  idHash: string;
  accountType: string;
  id: number;
  login: number;
}

export const apiTradingAccountUser = {
  getAccountInfo: async (tradingAccountId: number) => {
    return await fetchApi.get<IApiMTradingAccount>(ApiUrls.tradingAccountUser.get, {
      params: { id: tradingAccountId },
    });
  },
  sync: async (tradingAccountId: number) => {
    return await fetchApi.post<void>(ApiUrls.tradingAccountUser.sync, {}, { params: { id: tradingAccountId } });
  },
  syncAll: async () => {
    return await fetchApi.post<void>(ApiUrls.tradingAccountUser.syncAll);
  },
  createSelfTradeAccount: async (form: Record<string, unknown>) => {
    return await fetchApi.post<IAccountCreatedResponse>(ApiUrls.tradingAccountUser.selfTradeAccountCreate, form);
  },
  setAccountNotification: async (data: unknown) => {
    return await fetchApi.post<void>(ApiUrls.tradingAccountUser.setAccountNotification, data);
  },
};
